import GenericTableResponse from "@/models/api/GenericTableResponse";
import { OrderListItem } from "@/models/api/orders/OrderListItem";

export default {
  items: [
    {
      id: "6704e6a9-5e9a-4c5b-8dde-837a52701a6c",
      owner: "00000000-0000-0000-0000-000000000000",
      createdAt: "2021-01-13T12:51:33.737",
      gross: 509.69,
      comment: "Test komentarz",
      currency: "PLN",
      contractors: [
        {
          $id: "7",
          name: "AFPARTNER Sp. z o.o.",
          surname: "",
          tin: "8133614828",
          city: "Rzeszów",
          streetAndNumber: "Litewska 10 lok. 2a",
          postalCode: "35-302",
          relationType: 2,
        },
      ],
      documents: [
        {
          $id: "8",
          id: "988d4678-301c-4347-af5b-429161c20510",
          documentNumber: "54/01/2021/RZE",
          price: 0,
          formOfPaymentId: 0,
          isCancelled: false,
          recordStampId: 7897006,
        },
      ],
      canEdit: false,
      hasImportedContractor: true,
      hasBuyer: true,
      onlyReceiptIssued: false,
      isExported: false,
      isFromExport: false,
      isCorrection: false,
      hasReceipt: false,
      isTemporary: false,
      setTemporaryPermission: true,
      recordStampId: 7897011,
      stateToSendDocumentsView: 20,
      isMailReminder: false,
      canMakeCorrection: true,
      advanceIsImportedToDocument: false,
    },
    {
      $id: "9",
      id: "0be3c4ae-b9a7-4223-926e-6459b68e6224",
      createdAt: "2021-01-13T12:01:10.373",
      gross: 180,
      comment: "",
      currency: "PLN",
      contractors: [
        {
          $id: "10",
          name: "Klient Indywidualny  JAKUB",
          surname: "GÓRSKI",
          tin: null,
          city: null,
          streetAndNumber: null,
          postalCode: null,
          relationType: 2,
        },
      ],
      documents: [
        {
          $id: "11",
          id: "f380546b-21c4-4a36-ad4d-e3fb664ddc93",
          documentNumber: "PA 9/2021",
          price: 0,
          formOfPaymentId: 0,
          isCancelled: true,
          recordStampId: 7896991,
        },
        {
          $id: "12",
          id: "37650aeb-52ab-45fc-a221-b4abbd015aff",
          documentNumber: "53/01/2021/RZE",
          price: 0,
          formOfPaymentId: 0,
          isCancelled: false,
          recordStampId: 7896994,
        },
      ],
      canEdit: false,
      hasImportedContractor: false,
      hasBuyer: true,
      onlyReceiptIssued: false,
      isExported: false,
      isFromExport: false,
      isCorrection: false,
      hasReceipt: true,
      isTemporary: false,
      setTemporaryPermission: true,
      recordStampId: 7896984,
      stateToSendDocumentsView: 20,
      isMailReminder: false,
      canMakeCorrection: true,
      advanceIsImportedToDocument: false,
    },
    {
      $id: "13",
      id: "7881786a-c050-4821-be5c-b617b67278bb",
      createdAt: "2021-01-13T11:37:19.683",
      gross: 2267.59,
      comment: "",
      currency: "PLN",
      contractors: [
        {
          $id: "14",
          name: "Agencja Turystyczna ITA Beata Gruntowicz",
          surname: null,
          tin: "5421040057",
          city: "Białystok",
          streetAndNumber: "Św. Rocha 33 lok. 16",
          postalCode: "15-879",
          relationType: 2,
        },
      ],
      documents: [],
      canEdit: true,
      hasImportedContractor: true,
      hasBuyer: true,
      onlyReceiptIssued: false,
      isExported: false,
      isFromExport: false,
      isCorrection: false,
      hasReceipt: false,
      isTemporary: true,
      setTemporaryPermission: true,
      recordStampId: 7896978,
      stateToSendDocumentsView: 10,
      isMailReminder: false,
      canMakeCorrection: false,
      advanceIsImportedToDocument: false,
    },
    {
      $id: "15",
      id: "edc6929d-0362-49ee-9f62-c3d2a605b49b",
      createdAt: "2021-01-13T09:55:02.827",
      gross: 434.1,
      comment: "",
      currency: "PLN",
      contractors: [
        {
          $id: "16",
          name: "Polindus Sp. z o.o.",
          surname: null,
          tin: "6760076733",
          city: "Kraków",
          streetAndNumber: "Pl. Matejki 5/15",
          postalCode: "31-157",
          relationType: 2,
        },
      ],
      documents: [],
      canEdit: true,
      hasImportedContractor: true,
      hasBuyer: true,
      onlyReceiptIssued: false,
      isExported: false,
      isFromExport: false,
      isCorrection: false,
      hasReceipt: false,
      isTemporary: true,
      setTemporaryPermission: true,
      recordStampId: 7896931,
      stateToSendDocumentsView: 10,
      isMailReminder: false,
      canMakeCorrection: false,
      advanceIsImportedToDocument: false,
    },
    {
      $id: "17",
      id: "55f58257-4094-4c03-8a23-1ff31187707a",
      createdAt: "2021-01-13T09:31:37.777",
      gross: 5908.23,
      comment: "Usługa sprzedana w imieniu i na rzecz linii lotniczej ujętej w pozycji jako sprzedawca.",
      currency: "PLN",
      contractors: [
        {
          $id: "18",
          name: "Why Not Fly Sp. z o.o.",
          surname: null,
          tin: "8133577984",
          city: "Tyczyn",
          streetAndNumber: "Kielnarowa 108A",
          postalCode: "36-020",
          relationType: 2,
        },
        {
          $id: "19",
          name: "POLSKIE LINIE LOTNICZE LOT S.A.",
          surname: null,
          tin: "5220002334",
          city: "WARSZAWA",
          streetAndNumber: "Ul. Komitetu Obrony Robotników 43",
          postalCode: "02-146",
          relationType: 6,
        },
      ],
      documents: [],
      canEdit: true,
      hasImportedContractor: true,
      hasBuyer: true,
      onlyReceiptIssued: false,
      isExported: false,
      isFromExport: false,
      isCorrection: false,
      hasReceipt: false,
      isTemporary: true,
      setTemporaryPermission: true,
      recordStampId: 7896921,
      stateToSendDocumentsView: 10,
      isMailReminder: false,
      canMakeCorrection: false,
      advanceIsImportedToDocument: false,
    },
    {
      $id: "20",
      id: "21ed0b60-6f45-405f-8e62-f616273d0a77",
      createdAt: "2021-01-13T09:10:54.827",
      gross: 3300.93,
      comment: "",
      currency: "PLN",
      contractors: [
        {
          $id: "21",
          name: "PRZEDSIĘBIORSTWO BADAŃ GEOFIZYCZNYCH SPÓŁKA Z OGRANICZONĄ ODPOWIEDZIALNOŚCIĄ",
          surname: null,
          tin: "5250002356",
          city: "Kraków",
          streetAndNumber: "Wadowicka  8A",
          postalCode: "30-415",
          relationType: 2,
        },
      ],
      documents: [],
      canEdit: true,
      hasImportedContractor: true,
      hasBuyer: true,
      onlyReceiptIssued: false,
      isExported: false,
      isFromExport: false,
      isCorrection: false,
      hasReceipt: false,
      isTemporary: true,
      setTemporaryPermission: true,
      recordStampId: 7896916,
      stateToSendDocumentsView: 10,
      isMailReminder: false,
      canMakeCorrection: false,
      advanceIsImportedToDocument: false,
    },
    {
      $id: "22",
      id: "41c6097d-05ed-485a-b0af-a9f14125e3c7",
      createdAt: "2021-01-13T03:16:32.637",
      gross: 13814.93,
      comment: "Usługa sprzedana w imieniu i na rzecz linii lotniczej ujętej w pozycji jako sprzedawca.",
      currency: "PLN",
      contractors: [
        {
          $id: "23",
          name: "Why Not Fly Sp. z o.o.",
          surname: null,
          tin: "8133577984",
          city: "Tyczyn",
          streetAndNumber: "Kielnarowa 108A",
          postalCode: "36-020",
          relationType: 2,
        },
        {
          $id: "24",
          name: "Why Not Fly Sp. z o.o.",
          surname: null,
          tin: "8133577984",
          city: "Tyczyn",
          streetAndNumber: "Kielnarowa 108A",
          postalCode: "36-020",
          relationType: 6,
        },
      ],
      documents: [],
      canEdit: true,
      hasImportedContractor: true,
      hasBuyer: true,
      onlyReceiptIssued: false,
      isExported: false,
      isFromExport: false,
      isCorrection: false,
      hasReceipt: false,
      isTemporary: true,
      setTemporaryPermission: true,
      recordStampId: 7896901,
      stateToSendDocumentsView: 10,
      isMailReminder: false,
      canMakeCorrection: false,
      advanceIsImportedToDocument: false,
    },
    {
      $id: "25",
      id: "31ed0ed5-5da5-4c7f-a916-7dba0cc17abe",
      createdAt: "2021-01-12T16:23:40.163",
      gross: 1884.56,
      comment: "",
      currency: "PLN",
      contractors: [
        {
          $id: "26",
          name: "WB Electronics S.A.",
          surname: "",
          tin: "5262168387",
          city: "Ożarów Mazowiecki",
          streetAndNumber: "Poznańska 129/133",
          postalCode: "05-850",
          relationType: 2,
        },
      ],
      documents: [],
      canEdit: true,
      hasImportedContractor: true,
      hasBuyer: true,
      onlyReceiptIssued: false,
      isExported: false,
      isFromExport: false,
      isCorrection: false,
      hasReceipt: false,
      isTemporary: true,
      setTemporaryPermission: true,
      recordStampId: 7896862,
      stateToSendDocumentsView: 10,
      isMailReminder: false,
      canMakeCorrection: false,
      advanceIsImportedToDocument: false,
    },
    {
      $id: "27",
      id: "ce2de680-f5e2-4c41-b5d0-dfdc8f8f0c75",
      createdAt: "2021-01-12T15:25:27.82",
      gross: 0,
      comment: "",
      currency: "PLN",
      contractors: [
        {
          $id: "28",
          name: '"BLUE SKY TRAVEL" SPÓŁKA Z OGRANICZONĄ ODPOWIEDZIALNOŚCIĄ',
          surname: "",
          tin: "7811699670",
          city: "Poznań",
          streetAndNumber: "Franklina Roosevelta  2",
          postalCode: "60-829",
          relationType: 2,
        },
      ],
      documents: [],
      canEdit: true,
      hasImportedContractor: true,
      hasBuyer: true,
      onlyReceiptIssued: false,
      isExported: false,
      isFromExport: false,
      isCorrection: false,
      hasReceipt: false,
      isTemporary: false,
      setTemporaryPermission: true,
      recordStampId: 7896835,
      stateToSendDocumentsView: 10,
      isMailReminder: false,
      canMakeCorrection: false,
      advanceIsImportedToDocument: false,
    },
    {
      $id: "29",
      id: "50a1f601-eb72-4a3c-b525-988ced19bfcb",
      createdAt: "2021-01-12T15:25:20.96",
      gross: 0,
      comment: "",
      currency: "PLN",
      contractors: [
        {
          $id: "30",
          name: '"BLUE SKY TRAVEL" SPÓŁKA Z OGRANICZONĄ ODPOWIEDZIALNOŚCIĄ',
          surname: "",
          tin: "7811699670",
          city: "Poznań",
          streetAndNumber: "Franklina Roosevelta  2",
          postalCode: "60-829",
          relationType: 2,
        },
      ],
      documents: [],
      canEdit: true,
      hasImportedContractor: true,
      hasBuyer: true,
      onlyReceiptIssued: false,
      isExported: false,
      isFromExport: false,
      isCorrection: false,
      hasReceipt: false,
      isTemporary: false,
      setTemporaryPermission: true,
      recordStampId: 7896832,
      stateToSendDocumentsView: 10,
      isMailReminder: false,
      canMakeCorrection: false,
      advanceIsImportedToDocument: false,
    },
    {
      id: "192517c0-4018-4063-8654-fa39be9fcaf4",
      createdAt: "2021-01-22T15:12:57.347",
      gross: 373.99,
      comment: "",
      currency: "PLN",
      contractors: [
        {
          name: "BOUTIQUARC-HOTEL Kft.",
          surname: null,
          tin: "HU25785285",
          city: "Budapest",
          streetAndNumber: "Madách tér 3-4",
          postalCode: "1075",
          relationType: 2,
        },
      ],
      documents: [
        {
          id: "c2467ab2-4058-4d6f-9a92-d3f7dbb98b89",
          // DocumentNumber: "13/01/2021/RZE",
          // Price: 0.0,
          // FormOfPaymentId: 0,
          // IsCancelled: false,
          recordStampId: 7827156,
        },
      ],
      canEdit: false,
      hasImportedContractor: true,
      hasBuyer: true,
      onlyReceiptIssued: false,
      isExported: false,
      isFromExport: false,
      isCorrection: false,
      hasReceipt: false,
      isTemporary: false,
      setTemporaryPermission: true,
      recordStampId: 7827154,
      stateToSendDocumentsView: 20,
      isMailReminder: false,
      canMakeCorrection: true,
      advanceIsImportedToDocument: false,
    },
  ],
  totalCount: 28,
} as GenericTableResponse<OrderListItem>;
